

// Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Linkedin, Instagram, Menu, X } from 'lucide-react';
import { logo } from './index'

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 w-full z-50">
      {/* Top Contact Bar */}
      <div className="w-full bg-black/30 text-white py-2 px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
          <div className="flex items-center space-x-2">
            <Phone size={16} />
            <a href="tel:+919356936283" className="hover:underline text-sm">
              +91 9356936283
            </a>
          </div>
          <div className="flex items-center space-x-2">
            <Mail size={16} />
            <a href="mailto:synergyinnovativeenterprises@gmail.com" className="hover:underline text-sm">
              synergyinnovativeenterprises@gmail.com
            </a>
          </div>
        </div>


        <div className="flex items-center space-x-4 mt-2 md:mt-0">
          <div className="flex justify-start space-x-4 mt-4">
            <a
              href="https://www.facebook.com/profile.php?id=61576067675850#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook size={20} className="text-gray-300 hover:text-white" />
            </a>
            <a
              href="https://www.instagram.com/synergyexport/?fbclid=IwZXh0bgNhZW0CMTEAYnJpZBExUDhzQUJ5Nk9Ndkg2V3pMZwEeRaxoEdSouuWBi0yjCKkXlTAdK6IjK6Ouz3RZuDmaSjXveZR9mYR7o-WpSuo_aem_a2WIlTt1IU7wGYND2df19w"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={20} className="text-gray-300 hover:text-white" />
            </a>
          </div>

        </div>
      </div>

      {/* Main Navigation */}
      <div className="w-full bg-transparent py-4 px-6 flex justify-between items-center h-20">
        <div className="flex items-center space-x-3 h-full">
          <img
            src={logo}
            alt="Logo"
            className="max-h-24 md:max-h-28 w-auto object-contain"
          />
        </div>

        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="text-white hover:text-amber-200 text-lg">Home</Link>
          <Link to="/aboutus" className="text-white hover:text-amber-200 text-lg">About Us</Link>
          <Link to="/categories" className="text-white hover:text-amber-200 text-lg">Categories</Link>
          <Link to="/certificates" className="text-white hover:text-amber-200 text-lg">Certificate</Link>
          <Link to="/contact-us" className="text-white hover:text-amber-200 text-lg">Contact Us</Link>
        </nav>

        <button className="md:hidden text-white" onClick={() => setMenuOpen(true)}>
          <Menu size={32} />
        </button>
      </div>


      {/* Mobile Menu */}
      <div className={`fixed inset-0 bg-black/50 z-50 transition-opacity duration-300 ${menuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={() => setMenuOpen(false)}>
        <div className={`absolute right-0 top-0 h-full w-64 bg-white transform transition-transform duration-300 ${menuOpen ? 'translate-x-0' : 'translate-x-full'}`}
          onClick={(e) => e.stopPropagation()}>
          <div className="flex justify-between items-center p-4 border-b">
            <div className="flex items-center space-x-2">
              <img src={logo} alt="Logo" className="w-12 h-12 object-contain" />
              {/* <h1 className="text-xl font-serif text-[#73340E]">Global Greet</h1> */}
            </div>
            <button className="text-gray-600 hover:text-gray-800" onClick={() => setMenuOpen(false)}>
              <X size={24} />
            </button>
          </div>
          <nav className="flex flex-col p-4 space-y-4">
            <Link to="/" className="text-gray-700 hover:text-amber-600">Home</Link>
            <Link to="/aboutus" className="text-gray-700 hover:text-amber-600">About Us</Link>
            <Link to="/categories/dehydrated-products" className="text-gray-700 hover:text-amber-600">Dehydrated Products</Link>
            <Link to="/categories/turmeric-powder" className="text-gray-700 hover:text-amber-600">Turmeric Powder</Link>
            <Link to="/categories/chilly-powder" className="text-gray-700 hover:text-amber-600">Chilly Powder</Link>
            <Link to="/certificates" className="text-gray-700 hover:text-amber-600">Certificate</Link>
            <Link to="/contact-us" className="text-gray-700 hover:text-amber-600">Contact Us</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;